<script lang="ts">
  import type { ICustomFieldSchemaDTO } from "../../services/DTO";
  import type { ICustomField } from "../../utils/CustomFieldEntities/custom-field";
  import CustomField from "./CustomField.svelte";

  export let schemas: ICustomFieldSchemaDTO[];
  export let values: ICustomField;

  $: rowIndexes = !schemas
    ? []
    : schemas
        .map((x) => x.customFieldSchema.detailDisplayRow)
        .filter((value, index, array) => array.indexOf(value) === index)
        .sort((a, b) => a - b);

  function getFieldsOnRow(rowIndex: number): ICustomFieldSchemaDTO[] {
    return schemas
      .filter((x) => x.customFieldSchema.detailDisplayRow === rowIndex)
      .sort(
        (x, y) =>
          x.customFieldSchema.detailDisplayCol -
          y.customFieldSchema.detailDisplayCol
      );
  }
</script>

{#each rowIndexes as rowIndex}
  <div class="columns">
    {#each getFieldsOnRow(rowIndex) as schema}
      <div class="column">
        <CustomField
          {schema}
          bind:value={values[schema.customFieldSchema.fieldName]}
        />
      </div>
    {/each}
  </div>
{/each}
